// src/lib/constants.tsx
import { Gift, Scroll, Printer, Zap } from "lucide-react";

/**
 * MASTER SUBSCRIPTION PLANS
 * Centralized source for App.tsx, Settings.tsx, and Rewards.tsx
 */
export const PRO_PLANS = [
  {
    points: 2500,
    days: 7,
    label: "7 Days Premium",
    price: 25,
    originalPrice: 50,
    discount: "50%",
    features: [
      "No ads",
      "Saathi AI assistant",
      "GST Filing (GSTR-1 + 3B)"
    ]
  },
  {
    points: 5000,
    days: 15,
    label: "15 Days Premium",
    price: 50,
    originalPrice: 100,
    discount: "50%",
    features: [
      "No ads",
      "Saathi AI assistant",
      "GST Filing (GSTR-1 + 3B)"
    ]
  },
  {
    points: 10000,
    days: 30,
    label: "30 Days Premium",
    price: 99,
    originalPrice: 198,
    discount: "50%",
    features: [
      "No ads",
      "Saathi AI assistant",
      "GST Filing (GSTR-1 + 3B)",
      "Priority WhatsApp Support"
    ]
  },
  {
    points: 120000,
    days: 365,
    label: "365 Days Premium",
    price: 999,
    originalPrice: 1998,
    discount: "50%",
    features: [
      "No ads, all year",
      "Saathi AI + GST Filing",
      "Priority WhatsApp Support",
      "Maximum savings for 1 year"
    ]
  },
];

/**
 * ULTIMATE PLAN — yearly one-time, grants desktop access + 2 desktops
 */
export const ULTIMATE_PLAN = {
  id: "ultimate_yearly",
  label: "Ultimate Yearly",
  days: 365,
  price: 1999,
  originalPrice: 2999,
  discount: "33%",
  isOneTime: true,
  trialDays: 30,
  features: [
    "Everything in Premium",
    "Desktop app access (up to 2 desktops)",
    "AI Weekly Insights",
    "Priority support",
    "30-day free trial",
  ],
};

/**
 * MASTER PHYSICAL REWARDS
 * Centralized source for Rewards.tsx
 */
export const PHYSICAL_REWARDS = [
  {
    id: "amazon_50",
    name: "₹50 Amazon Voucher",
    icon: <Gift className="h-6 w-6 text-orange-500" />,
    points: 5000,
    price: null // Points ONLY
  },
  {
    id: "amazon_100",
    name: "₹100 Amazon Voucher",
    icon: <Gift className="h-6 w-6 text-orange-500" />,
    points: 10000,
    price: null // Points ONLY
  },
  {
    id: "thermal_rolls",
    name: "58mm Thermal Paper Rolls (Pack of 5)",
    icon: <Scroll className="h-6 w-6 text-slate-500" />,
    points: 20000,
    price: 199 // Points OR Cash
  },
  {
    id: "bt_printer",
    name: "Bluetooth Thermal Printer",
    icon: <Printer className="h-6 w-6 text-blue-500" />,
    points: 300000,
    price: 2999 // Points OR Cash
  },
];

/**
 * GLOBAL UI SETTINGS
 */
export const RENEWAL_DISCLAIMER = "Plan renews automatically. Cancel anytime.";